import React from "react";
import { Instagram, Mail } from "lucide-react";
import { WhatsAppIcon } from "./icons";
import { CONFIG, waLink, NAV } from "../data/content";
import { Reveal, Eyebrow } from "./Reveal";

export const Footer = () => (
  <footer
    className="relative bg-[#21070D] pt-24 sm:pt-32 pb-10 px-6 sm:px-10 md:px-16 grain"
    data-testid="footer"
  >
    <div className="relative z-10 max-w-6xl mx-auto">
      <div className="text-center max-w-3xl mx-auto">
        <Reveal>
          <Eyebrow className="text-[#EBD08A]">Begin Your Journey</Eyebrow>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-serif font-medium text-[#F4EBD9] text-4xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight">
            Ready to find your next chapter?
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-6 text-[#D8C3B8] text-lg sm:text-xl body-serif">
            Reach out and let's find a time that feels right for you.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={waLink()}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-whatsapp-btn"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] text-white px-8 py-4 text-sm font-semibold hover:opacity-90 transition-opacity"
            >
              <WhatsAppIcon className="h-5 w-5" /> Chat on WhatsApp
            </a>
            <a
              href={`mailto:${CONFIG.email}`}
              data-testid="footer-email-btn"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-[#D9B24A]/50 text-[#F4EBD9] px-8 py-4 text-sm font-semibold hover:border-[#D9B24A] hover:text-[#D9B24A] transition-colors"
            >
              <Mail size={18} /> Email Shreya
            </a>
          </div>
        </Reveal>
      </div>

      <div className="mt-24 pt-10 border-t border-[#D9B24A]/20 flex flex-col md:flex-row items-center justify-between gap-8">
        <div className="text-center md:text-left">
          <div className="font-serif text-2xl text-[#F4EBD9]">{CONFIG.brand}</div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#D9B24A] mt-1">
            {CONFIG.tagline}
          </div>
        </div>

        <nav className="flex flex-wrap justify-center gap-6">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="text-xs uppercase tracking-[0.2em] text-[#C8AFA5] hover:text-[#F4EBD9] transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex gap-3">
          <a
            href={CONFIG.instagram}
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
            data-testid="footer-instagram"
            className="grid place-items-center h-11 w-11 rounded-full border border-[#D9B24A]/40 text-[#F4EBD9] hover:bg-[#EBD08A] hover:border-[#EBD08A] hover:text-[#21070D] transition-colors"
          >
            <Instagram size={18} />
          </a>
          <a
            href={`mailto:${CONFIG.email}`}
            aria-label="Email"
            className="grid place-items-center h-11 w-11 rounded-full border border-[#D9B24A]/40 text-[#F4EBD9] hover:bg-[#EBD08A] hover:border-[#EBD08A] hover:text-[#21070D] transition-colors"
          >
            <Mail size={18} />
          </a>
        </div>
      </div>

      <div className="mt-10 text-center text-xs text-[#C8AFA5]/60">
        © {new Date().getFullYear()} {CONFIG.brand}. Made with devotion.
      </div>
    </div>
  </footer>
);
